<section class="header container-fluid">
    <div class="row d-flex align-items-center py" #header>
        <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="header_flx">
                <div class="header_logo">
                    <div class="application-logo">
                        <img src="\assets\images\common\login\grow_logo.png" class="grow_logo" alt="logo">
                    </div>
                </div>
                <!-- <div class="d-flex cursor-pointer"  >
                    <div class="d-flex align-items-center logout_btn" (click)="showPopup=true">
                        <p class="mb-0 profile_avatar avatar-image mx-1">
                            <img [src]="getProfilePhoto()" alt="logo_profile" > 
                        </p>
                        <div class="profile-arrow mx-1">
                            <img src="/assets/images/common/icons/dropdown_arrow.svg" alt="arrow" >
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="showPopup">
                    <div class="profile-popup-container" (mouseleave)="showPopup=false" >
                        <div class="profile-items d-flex flex-column py-2">
                            
                            <div class="profile-item fs-14 cursor-pointer p-2" (click)="logout()">
                                <img   class="img" src="/assets/images/common/icons/logout.svg" alt="" >
                                <a>Logout</a>
                            </div>
                        </div>
                    </div>
                </ng-container> -->
                

                <!-- User Profile -->
                <div class="jd_profile">

                    <!-- <div class="pointerEventNone">
                        <img src="/assets/images/common/icons/notification_icon.svg" alt="">
                    </div> -->


               

                    <div class="p-1 cursor-pointer login_flx login_flx_logo " [matMenuTriggerFor]="profilePopUpBox">
                        <!-- <span class="notification">
                            <img src="assets/images/layout/header/notofication.svg" class="img-fluid">
                        </span>  -->
                        <div class="profile_icn">
                            {{userName}}
                        </div>
                    </div>
                </div>




                <mat-menu #profilePopUpBox="matMenu" class="profile-pop-up-box border-8px">
                    <div class="popup_width">
                        <div class="popup_body">
                            <div class="">
                                <div class="d-flex flex-column username_section">
                                    <label for="username" class="text-capitalize username_label">

                                        <span class="user_fs fs-14">{{userDetails?.username || userDetails?.full_name}}</span>
                                    </label>
                                    <label for="username" class=" text-capitalize">

                                        <span class=" user_fs  fs-12 role_type">{{userDetails?.group?.name || ''}}</span>
                                        <span *ngIf="entityName?.length" class="d-block department_text">
                                            <span class=" user_fs  " [matTooltip]="entityName">{{entityName || ''}}</span>
                                        </span>
                                    </label>
                                </div>

                                
                            </div>

                            <div class="myprofile_section">
                                <span (click)="userProfile()" (keydown)="userProfile()" class=" my_profile" [innerHtml]="staticText?.header?.header_button_3">
                                </span>
                                <!-- <span class="mt-2 help_text" [innerHtml]="staticText?.header?.header_label_1">
                                </span> -->
                                <span class=" text-capitalize logout_text" (click)="logout()" (keydown)="logout()" >
                                    <span class="fs-13 mb-0 cursor-pointer" [innerHtml]="staticText?.header?.header_button_1">
                                    </span>
                                </span>
                                <span class="last_login" *ngIf="lastlogin">
                                    <span>Last Login :</span>
                                    {{ lastloginFormatted }}
                                </span>
                                </div>

                            <!-- <div class="last_login_section">
                                <div class="fs-12" [innerHtml]="staticText?.header?.header_label_2">
                                </div>
                            </div> -->
                        </div>
                    </div>
                </mat-menu>

            </div>
        </div>

    </div>
</section>

<!-- <ng-container *ngIf="showNotificationPopUp">
    <div class="log-container" id="notificationBox">
        <div class="arrow-top"></div>
        <div class="pt-4 p-2">
            <div class="d-flex flex-column cursor-pointer">
                <div class="p-1 border-bottom">
                    <h5 class="color-Port-Gore fs-14">Notification List</h5>
                </div>
                <div class="popup_body">
                    <ul class="list-group">
                        <li class="list-group-item">Cras justo odio</li>
                        <li class="list-group-item">Dapibus ac facilisis in</li>
                        <li class="list-group-item">Morbi leo risus</li>
                        <li class="list-group-item">Porta ac consectetur ac</li>
                        <li class="list-group-item">Vestibulum at eros</li>
                        <li class="list-group-item">Morbi leo risus</li>
                        <li class="list-group-item">Porta ac consectetur ac</li>
                        <li class="list-group-item">Vestibulum at eros</li>
                        <li class="list-group-item">Morbi leo risus</li>
                        <li class="list-group-item">Porta ac consectetur ac</li>
                        <li class="list-group-item">Vestibulum at eros</li>
                        <li class="list-group-item">Morbi leo risus</li>
                        <li class="list-group-item">Porta ac consectetur ac</li>
                        <li class="list-group-item">Vestibulum at eros</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</ng-container> -->